export const USER_REGISTER = `mutation userRegister($email:String! $password:String! $registrationToken:String!){
    userRegister(input:{
      email:$email
      password:$password
      registrationToken:$registrationToken
    }) {
      requiresConfirmation
    }
  }`;
